/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actuator_Type_Three_Way_ValveInputs */



/**
* | output |
* | --- |
* | "3-way valve" |
*
* @param {Actuator_Type_Three_Way_ValveInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const actuator_type_three_way_valve = /** @type {((inputs?: Actuator_Type_Three_Way_ValveInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actuator_Type_Three_Way_ValveInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("3-way valve")
	return /** @type {LocalizedString} */ ("Vanne 3 voies")
});